import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { BlockedListSection } from "Pages/People/BlockedListSection";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

/** The personas the caller has blocked, linked from the bottom of the People page. */
export const BlockedUsersPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.BlockedUsers)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("people"),
      }}
    >
      <StyledPageWrapper>
        <Stack className="left-content" gap={2} mb={6}>
          <BlockedListSection />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
